import { firstValueFrom, map, Observable } from 'rxjs';
import { CaqRequestService } from '../'
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PQRQuadroFuncionariosRemuneracaoDto } from '../../dtos/pqr-quadro-funcionarios-remuneracao.dto';

interface ListPQRQuadroFuncionariosRemuneracao {
  _embedded: {
    'pqr-quadro-funcionarios-remuneracao': PQRQuadroFuncionariosRemuneracaoDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRQuadroFuncionariosRemuneracaoService {
  private apiUrl = `${environment.apiUrl}/pqr-quadro-funcionarios-remuneracao`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  private corrigirData(data: string) {
    const [ano, mes, _dia] = data.split('-');
    return `${mes}-${ano}`;
  }

  buscarListaDePQRQuadroFuncionariosRemuneracao(): Observable<PQRQuadroFuncionariosRemuneracaoDto[]> {
    return this.caqRequestService
      .get<ListPQRQuadroFuncionariosRemuneracao>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-quadro-funcionarios-remuneracao']))
      .pipe(map((valores) => valores.map((valor) => ({
        ...valor
      }))));
  }

  salvePQRQuadroRemuneracao(requisicao: PQRQuadroFuncionariosRemuneracaoDto){
    return firstValueFrom(this.caqRequestService
      .put<PQRQuadroFuncionariosRemuneracaoDto>(`${this.apiUrl}/${requisicao.codPqrQuadroFuncionariosRemuneracao}`, requisicao)
      .pipe(map((response) => response)));
  }
}
